export const courses = [
  {
    id: 11,
    title: "Free Project: AWS Cloud Fun Facts Generator",
    price: 0,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/6.png",
    description: "Start your cloud journey with something fun. The Cloud Fun Facts Generator is a free mini-project where you'll create an app that shares surprising cloud trivia. AWS services used include DynamoDB, Bedrock, Lambda and more.",
    level: "Beginner",
    isFree: true
  },
  {
    id: 1,
    title: "AWS Interview Mastery",
    price: 129,
    originalPrice: null,
    category: "career",
    enrolled: false,
    image: "/course-covers/1.png",
    description: "Get hired in the cloud!",
    level: "All Levels"
  },
  {
    id: 2,
    title: "The Part-Time Tech Career YouTuber",
    price: 129,
    originalPrice: null,
    category: "career",
    enrolled: false,
    image: "/course-covers/11.png",
    description: "Build your tech career while working part-time",
    level: "All Levels"
  },
  {
    id: 3,
    title: "Study Notes: AWS Certified AI Practitioner",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/study-notes-ai-practitioner.png",
    description: "Complete study guide for AI certification",
    level: "Beginner"
  },
  {
    id: 4,
    title: "Study Notes: AWS Certified Cloud Practitioner",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/7.png",
    description: "Essential notes for cloud certification",
    level: "Beginner"
  },
  {
    id: 5,
    title: "Study Notes: AWS Certified Solutions Architect - Associate",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/10.png",
    description: "Comprehensive SA-A study materials",
    level: "Intermediate"
  },
  {
    id: 14,
    title: "Study Notes: AWS Certified Developer - Associate",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/study-notes-developer-associate.jpg",
    description: "Complete study guide for AWS Developer certification",
    level: "Intermediate"
  },
  {
    id: 20,
    title: "Study Notes: AWS Certified CloudOps Engineer - Associate",
    price: 39,
    originalPrice: null,
    category: "study-notes",
    enrolled: false,
    image: "/course-covers/study-notes-cloudops.png",
    description: "Complete Study Notes to help you ace your AWS CloudOps Engineer Associate Certification Exam. Perfect revision guide with detailed explanations and visual diagrams.",
    level: "Intermediate"
  },
  {
    id: 12,
    title: "AWS Certified Cloud Practitioner Practice Tests",
    price: 29,
    originalPrice: null,
    category: "practiceExams",
    enrolled: false,
    image: "/course-covers/practice-exams-cloud-practitioner.png",
    description: "Complete practice exams with explanations",
    level: "All Levels"
  },
  {
    id: 13,
    title: "AWS Certified AI Practitioner Practice Tests",
    price: 29,
    originalPrice: null,
    category: "practiceExams",
    enrolled: false,
    image: "/course-covers/ai-practice-tests.png",
    description: "More courses coming!",
    level: "All Levels"
  },
  {
    id: 15,
    title: "AWS Certified Solutions Architect - Associate Practice Tests",
    price: 29,
    originalPrice: null,
    category: "practiceExams",
    enrolled: false,
    image: "/course-covers/practice-exams-solutions-architect.png",
    description: "Complete practice exams for Solutions Architect certification",
    level: "Intermediate"
  },
  {
    id: 21,
    title: "AWS Certified Developer - Associate Practice Tests",
    price: 29,
    originalPrice: null,
    category: "practiceExams",
    enrolled: false,
    image: "/course-covers/practice-exams-developer-associate.jpg",
    description: "Complete practice exams for AWS Developer Associate certification with detailed explanations",
    level: "Intermediate",
    externalUrl: "https://learn.zerotocloud.co/p/aws-developer-associate-practice-tests"
  },
  {
    id: 9,
    title: "Build: 5 Beginner AWS Cloud Projects",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/2.png",
    description: "Perfect for cloud beginners",
    level: "Beginner"
  },
  {
    id: 10,
    title: "Build: 5 Intermediate AWS Cloud Projects",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/3.png",
    description: "Level up your cloud skills",
    level: "Intermediate"
  },
  {
    id: 8,
    title: "Build: 5 Advanced AWS Cloud Projects",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/4.png",
    description: "Master advanced cloud concepts",
    level: "Advanced"
  },
  {
    id: 6,
    title: "5 AWS Cloud Projects to Become a Cloud Support Engineer",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/cloud-support-engineer-projects.jpg",
    description: "Launch your cloud support career",
    level: "Beginner"
  },
  {
    id: 7,
    title: "5 AWS Cloud Projects to Become a Solutions Architect",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/solutions-architect.png",
    description: "Design scalable cloud architectures",
    level: "Intermediate"
  },
  {
    id: 18,
    title: "5 AWS Projects to Become a Cloud Engineer",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/cloud-engineer-projects.png",
    description: "Complete Step-By-Step Guide to five AWS Projects to help you get hired as a Cloud Engineer. Build these high-quality projects, and add them to your portfolio!",
    level: "Intermediate"
  },
  {
    id: 16,
    title: "5 AWS Projects to Become a Cloud AI/ML Engineer",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/ai-ml-engineer-projects.png",
    description: "Build real-world AI/ML projects on AWS and launch your cloud AI career",
    level: "Intermediate"
  },
  {
    id: 17,
    title: "5 AWS Projects to Become a Cloud Security Engineer",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/cloud-security-engineer-projects.png",
    description: "Master cloud security with 5 hands-on AWS projects. Learn to secure cloud infrastructure, implement IAM policies, and build security monitoring systems.",
    level: "Intermediate"
  },
  {
    id: 19,
    title: "5 AWS Cloud Projects to Become a DevOps Engineer",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/devops-engineer-projects.png",
    description: "Complete Step-By-Step Guide to five AWS Projects to help you get hired as a DevOps Engineer. Build CI/CD pipelines, Infrastructure as Code, Kubernetes deployments, and more.",
    level: "Advanced"
  },
  {
    id: 22,
    title: "5 Beginner Azure Cloud Projects",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/azure-beginner-projects.png",
    description: "Complete Step-By-Step Guide to five Beginner Azure Projects. Build these projects over a weekend using Azure Static Web Apps, Cosmos DB, Azure Functions, AI Vision, AI Speech, App Service, Azure SQL, and Microsoft Entra ID — and add them to your portfolio.",
    level: "Beginner",
    externalUrl: "https://learn.zerotocloud.co/p/5-beginner-azure-cloud-projects"
  },
  {
    id: 23,
    title: "Study Notes: Azure Fundamentals",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/study-notes-azure-fundamentals.png",
    description: "Complete Study Notes to help you ace your Azure Fundamentals (AZ-900) exam. Detailed explanations, visual diagrams, analogies, and more — perfect for revision or as a first-time learning guide.",
    level: "Beginner",
    externalUrl: "https://learn.zerotocloud.co/p/study-notes-azure-fundamentals"
  },
  {
    id: 24,
    title: "Study Notes: Azure Administrator Associate",
    price: 39,
    originalPrice: null,
    category: "studyNotes",
    enrolled: false,
    image: "/course-covers/study-notes-azure-administrator.png",
    description: "Complete Study Notes to help you ace your Azure Administrator Associate (AZ-104) exam. Detailed explanations, visual diagrams, analogies, and more — perfect for revision or as a first-time learning guide.",
    level: "Intermediate",
    externalUrl: "https://learn.zerotocloud.co/p/study-notes-azure-administrator-associate"
  },
  {
    id: 25,
    title: "5 Intermediate Azure Cloud Projects",
    price: 69,
    originalPrice: null,
    category: "projects",
    enrolled: false,
    image: "/course-covers/azure-intermediate-projects.png",
    description: "Complete Step-By-Step Guide to five Intermediate Azure Projects. Build a serverless job board, a sales analytics pipeline, an AI resume screener, a cloud service comparison app, and a cheat sheet library using Azure Functions, Data Factory, Power BI, AI Document Intelligence, Cosmos DB, App Gateway, and more.",
    level: "Intermediate",
    externalUrl: "https://learn.zerotocloud.co/p/5-intermediate-azure-cloud-projects"
  },];

// DevOps Engineer Projects (id: 19) and CloudOps Study Notes (id: 20) added

export const bundles = [
  {
    id: 1,
    title: "AWS Projects Bundle",
    description: "3 Courses",
    originalPrice: 207,
    discountedPrice: 149,
    savings: 58,
    courses: [
      "Build: 5 Beginner AWS Cloud Projects",
      "Build: 5 Intermediate AWS Cloud Projects", 
      "Build: 5 Advanced AWS Cloud Projects"
    ],
    image: "/bundle-covers/aws-projects.jpg"
  },
  {
    id: 2,
    title: "All-in-One Lifetime Access Bundle",
    description: "22 Courses",
    originalPrice: 1729,
    discountedPrice: 499,
    savings: 1230,
    courses: [
      "Study Notes: AWS Certified Cloud Practitioner",
      "Study Notes: AWS Certified AI Practitioner",
      "Study Notes: AWS Certified Solutions Architect - Associate",
      "Study Notes: AWS Certified Developer - Associate",
      "Study Notes: AWS Certified CloudOps Engineer - Associate",
      "AWS Certified Cloud Practitioner Practice Tests",
      "AWS Certified AI Practitioner Practice Tests",
      "AWS Certified Solutions Architect - Associate Practice Tests",
      "AWS Certified Developer - Associate Practice Tests",
      "Build: 5 Beginner AWS Cloud Projects",
      "Build: 5 Intermediate AWS Cloud Projects",
      "Build: 5 Advanced AWS Cloud Projects",
      "5 AWS Cloud Projects to Become a Cloud Support Engineer",
      "5 AWS Cloud Projects to Become a Solutions Architect",
      "5 AWS Projects to Become a Cloud Engineer",
      "5 AWS Projects to Become a Cloud AI/ML Engineer",
      "5 AWS Projects to Become a Cloud Security Engineer",
      "5 AWS Cloud Projects to Become a DevOps Engineer",
      "5 Beginner Azure Cloud Projects",
      "5 Intermediate Azure Cloud Projects",
      "Study Notes: Azure Administrator Associate",
      "AWS Interview Mastery",
      "The Part-Time Tech Career YouTuber"
    ],
    image: "/bundle-covers/all-in-one.jpg"
  },
  {
    id: 3,
    title: "Cloud Newbie Bundle", 
    description: "6 Courses",
    originalPrice: 399,
    discountedPrice: 149,
    savings: 250,
    courses: [
      "Build: 5 Beginner AWS Cloud Projects",
      "Study Notes: AWS Certified Cloud Practitioner", 
      "5 AWS Cloud Projects to Become a Cloud Support Engineer",
      "AWS Certified Cloud Practitioner Practice Tests",
      "5 Beginner Azure Cloud Projects",
      "Free Project: AWS Cloud Fun Facts Generator"
    ],
    image: "/bundle-covers/cloud-newbie.jpg"
  },
  {
    id: 4,
    title: "Ultimate Projects Bundle",
    description: "11 Courses",
    originalPrice: 899,
    discountedPrice: 299,
    savings: 600,
    courses: [
      "Build: 5 Beginner AWS Cloud Projects",
      "Build: 5 Intermediate AWS Cloud Projects",
      "Build: 5 Advanced AWS Cloud Projects",
      "5 AWS Cloud Projects to Become a Cloud Support Engineer",
      "5 AWS Cloud Projects to Become a Solutions Architect",
      "5 AWS Projects to Become a Cloud Engineer",
      "5 AWS Projects to Become a Cloud AI/ML Engineer",
      "5 AWS Projects to Become a Cloud Security Engineer",
      "5 AWS Cloud Projects to Become a DevOps Engineer",
      "5 Beginner Azure Cloud Projects",
      "5 Intermediate Azure Cloud Projects"
    ],
    image: "/bundle-covers/ultimate-projects.jpg"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Christian Deausen",
    location: "Washington, USA",
    text: "Lucy is highly knowledgeable in AWS, and her guidance through the 30-day challenge has been incredibly helpful for keeping up with the fast-changing cloud industry. The challenge with its study notes provided a structured approach to building a portfolio, working on projects, and gaining hands-on practical experience.",
    avatar: "/testimonials/christian.png"
  },
  {
    id: 2,
    name: "Prakriti Bhatia",
    location: "Sydney, Australia",
    text: "Lucy's AWS Interview Mastery course combines the best advice from her own experience at Amazon. It provided me invaluable insights into the tech & cloud interview process. The course contains mock interview examples from Amazon employees, which gave useful insights into the process. Would highly recommend checking out all the Zero To Cloud",
    avatar: "/testimonials/prakriti.jpg"
  },
  {
    id: 3,
    name: "Kamalpreet Kaur",
    location: "Laval, France",
    text: "The 30-day challenge gave me the chance to apply my knowledge of AWS to real-world scenarios. It helped me build a range of new projects to add to my portfolio. The most valuable part for me was the weekly mentorship sessions - very helpful and engaging. I'd highly recommend this challenge to anyone upskilling in AWS domain.",
    avatar: "/testimonials/kamapreet.png"
  },
  {
    id: 4,
    name: "Chris Roberts",
    location: "Jacksonville, Florida",
    text: "The Zero To Cloud '30-Day Challenge' helped me gain in-depth cloud knowledge and a strong understanding of AWS principles. Resources, like the study notes, were incredibly helpful, and the Slack community offered great support for asking questions & sharing ideas. I highly recommend this challenge to anyone looking to upskill.",
    avatar: "/testimonials/chris.jpg"
  }
];

export const features = [
  {
    id: 1,
    title: "Study Notes",
    description: "Comprehensive study materials and cheat sheets",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Hands-on Projects", 
    description: "Step-by-step instructions to build real-world cloud projects",
    icon: "Code"
  },
  {
    id: 3,
    title: "Practice Exams",
    description: "Full certification exams with detailed explanations", 
    icon: "FileText"
  },
  {
    id: 4,
    title: "Career Roadmaps",
    description: "Follow clear paths to get hired in your dream job",
    icon: "Map"
  }
];

export const socialStats = [
  { platform: "YouTube", count: "200K", icon: "Youtube", url: "https://www.youtube.com/@TechwithLucy/" },
  { platform: "LinkedIn", count: "70K", icon: "Linkedin", url: "https://www.linkedin.com/in/lucywang-/" },
  { platform: "Twitter", count: "22K", icon: "Twitter", url: "https://x.com/TechWithLucy" },
  { platform: "Instagram", count: "12K", icon: "Instagram", url: "https://www.instagram.com/techwithlucy/" }
];

export const navigationItems = [
  { name: "Home", href: "/" },
  { name: "Learning Paths", href: "/learning-paths" },
  { name: "Courses", href: "/courses" },
  { name: "Bundles", href: "/bundles" },
  { name: "Free Resources", href: "#", isDropdown: true },
  { name: "About", href: "/about" }
];

// Note: Live Training removed from menu but /accelerator URL still active